export enum RightTab {
  CHART = 'CHART',
  TEXT = 'TEXT',
  FILTER = 'FILTER',
  LAYOUT = 'LAYOUT',
  NONE = 'NONE',
}
